import { usePathname, useLocalSearchParams } from 'expo-router';

export function useCurrentRoute() {
  const pathname = usePathname();
  const params = useLocalSearchParams();

  return {
    pathname,
    isHome: pathname === '/' || pathname === '/app',
    isAgents: pathname === '/agents' || pathname.startsWith('/agents/'),
    isMyAgents: pathname === '/agents/mine',
    isBuilder: pathname === '/builder',
    isLibrary: pathname === '/library',
    isTags: pathname === '/tags',
    isCollections: pathname === '/collections',
    isDiscover: pathname === '/discover',
    isModels: pathname === '/models',
    isFiles: pathname === '/files',
    isExplore: pathname === '/explore',
    isImages: pathname === '/images',
    isVideos: pathname === '/videos',
    isMusic: pathname === '/music',
    isTasks: pathname === '/tasks' || pathname.startsWith('/tasks/'),
    isCoworker: pathname === '/coworker' || pathname.startsWith('/coworker/'),
    isTools: pathname === '/tools' || pathname.startsWith('/tools/'),
    isPrompts: pathname === '/prompts' || pathname.startsWith('/prompts/'),
    isWorkflows: pathname === '/workflows' || pathname.startsWith('/workflows/'),
    isMemory: pathname === '/memory',
    isIdeas: pathname === '/ideas' || pathname === '/ideas/',
    isBookmarks: pathname === '/bookmarks',
    isDeck:
      pathname === '/deck'
      || pathname.startsWith('/deck/')
      || pathname === '/decks/recipes'
      || pathname.startsWith('/decks/recipes/'),
    isReferral: pathname === '/referral',
    isCollection: (id) => pathname === `/collections/${id}` || (pathname === '/files' && params.collection === id),
    isLibraryChat: (id) => pathname === `/c/${id}`,
    isTag: (id) => pathname === `/tags/${id}`,
    isAgent: (id) => pathname === `/g/${id}`,
    isModel: (id) => pathname === `/m/${id}`,
  };
} 